import React from "react";

const ChartSummaryRows = ({ rows = [] }) => {
  const visibleRows = rows.filter((row) => row && row.show !== false);

  if (!visibleRows.length) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 10,
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      {visibleRows.map((row) => (
        <div
          key={row.label}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: 4,
            padding: "4px 8px",
            fontSize: 12,
          }}
        >
          <span
            style={{
              width: 10,
              height: 10,
              background: row.color,
              display: "inline-block",
            }}
          />
          <span>{row.label}: {row.value}</span>
        </div>
      ))}
    </div>
  );
};

export default ChartSummaryRows;
